import axios from "axios";
import * as React from "react";
import { Grid, Icon, Image, List, Table } from "semantic-ui-react";
import formats from "../helpers/formats";
import resultadosService from "../services/resultados.service";
import Loader from "./Loader";

class Resultados extends React.Component {
    constructor(props) {
        super(props);

        try {
            const localState = localStorage.getItem("state");

            if (localState) {
                const state = JSON.parse(localState);
                localStorage.removeItem("state");
                this.state = { ...state };
            } else {
                this.state = {
                    isLoading: false,
                    dataSelecionada: undefined,
                    registros: [],
                    resultados: [],
                    pesquisa: "",
                    resposta: 0,
                };
            }
        } catch (e) {
            this.state = {
                isLoading: false,
                dataSelecionada: undefined,
                registros: [],
                resultados: [],
                pesquisa: "",
                resposta: 0,
            };
        }
    }

    async componentDidMount() {
        try {
            if (this.state.resultados.length === 0) {
                this.setState({ isLoading: true });
                const { data: registros } = await resultadosService.getRegistros();

                if (registros.length) {
                    this.setState({ registros });
                    this.onChangeDate(registros[0].ano);
                } else {
                    this.setState({ isLoading: false });
                }
            }
        } catch (err) {
            console.log(err);
            this.props.history.push("/");
        }
    }

    onChangeDate = async (value) => {
        this.setState({ dataSelecionada: value, isLoading: true });

        try {
            const { data: resultados } = await resultadosService.getResultados({ ano: value });
            this.setState({ isLoading: false, resultados }, () => localStorage.setItem("state", JSON.stringify(this.state)));
        } catch (err) {
            console.log(err);
            this.props.history.push("/");
        }
    };

    onPressAtendimento = async (atendimento) => {
        if (atendimento.disponivel) {
            this.setState({ ...this.state, isLoading: true });

            try {
                await resultadosService.getLaudo(atendimento);
            } catch (error) {
                console.log(error);
            }

            this.setState({ ...this.state, isLoading: false });
        }
    };

    onPressPesquisa = (e, atendimento, pesquisa) => {
        const {
            currentTarget: { href },
        } = e;
        axios.get(href);

        if (pesquisa.mensagem && window.confirm(pesquisa.mensagem)) {
            window.open(href, "_blank");
        } else {
            e.preventDefault();
        }

        atendimento.pesquisas = atendimento.pesquisas.filter((p) => p.codigo !== pesquisa.codigo);
        this.setState({ pesquisa: "", resposta: 0 });
    };

    getArrayFrom(count) {
        const arr = [];

        for (let index = 1; index <= count; index++) {
            arr.push(index);
        }

        return arr;
    }

    render() {
        const verificado = require("../img/verificado-sm.png");
        const andamento = require("../img/andamento-sm.png");
        const parcial = require("../img/parcial-sm.png");

        return (
            <Grid>
                <Loader isLoading={this.state.isLoading} />
                <Grid.Column width={16}>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                <List>
                                    <List.Item>
                                        <List.Icon name={this.state.dataSelecionada ? "folder" : "folder open"} />
                                        <List.Content>
                                            <List.Header>Todos os exames</List.Header>
                                            <List.List>
                                                {this.state.registros.length ? (
                                                    this.state.registros.map((item, index) => (
                                                        <List.Item key={index} onClick={() => this.onChangeDate(item.ano)}>
                                                            <List.Icon
                                                                name={this.state.dataSelecionada !== item.ano ? "folder" : "folder open"}
                                                            />
                                                            <List.Content>
                                                                <List.Header>
                                                                    {item.ano} ({item.quantidade})
                                                                </List.Header>
                                                            </List.Content>
                                                        </List.Item>
                                                    ))
                                                ) : (
                                                    <>
                                                        <List.Item onClick={() => this.componentDidMount()}>
                                                            <List.Icon name="times" />
                                                            <List.Content>
                                                                <List.Header>Não há resultados disponíveis</List.Header>
                                                            </List.Content>
                                                        </List.Item>
                                                    </>
                                                )}
                                            </List.List>
                                        </List.Content>
                                    </List.Item>
                                </List>
                            </Grid.Column>
                            <Grid.Column width={4}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={1}>
                                            <Image src={verificado} className="imgLegendaLaudos" />
                                        </Grid.Column>
                                        <Grid.Column width={11}>
                                            <label className="lblLegendaLaudos">Resultados Prontos</label>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={4}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={1}>
                                            <Image src={parcial} className="imgLegendaLaudos" />
                                        </Grid.Column>
                                        <Grid.Column width={11}>
                                            <label className="lblLegendaLaudos">Resultados Parciais</label>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={4}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={1}>
                                            <Image src={andamento} className="imgLegendaLaudos" />
                                        </Grid.Column>
                                        <Grid.Column width={11}>
                                            <label className="lblLegendaLaudos">Em Andamento</label>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Table celled striped className="marginTab">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Talão</Table.HeaderCell>
                                <Table.HeaderCell>Data</Table.HeaderCell>
                                <Table.HeaderCell colSpan="3">Nome do Paciente</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.state.resultados.map((item) => (
                                <Table.Row key={item.ateCod}>
                                    <Table.Cell collapsing>
                                        <Icon name="file outline" />
                                        {item.ateCod}
                                    </Table.Cell>
                                    <Table.Cell collapsing>{formats.toDate(item.ateData)}</Table.Cell>
                                    <Table.Cell>{item.pacNome}</Table.Cell>
                                    <Table.Cell textAlign="right">
                                        <Image.Group onClick={() => this.onPressAtendimento(item)}>
                                            <Image src={item.disponivel ? (item.possuiLaudoPendente ? parcial : verificado) : andamento} />
                                            {item.disponivel ? <Image src={require("../img/icon-pdf-sm.png")} /> : null}
                                        </Image.Group>
                                    </Table.Cell>
                                    <Table.Cell>
                                        {item.pesquisas.length ? (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexFlow: "column",
                                                    alignItems: "center",
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: 5,
                                                    width: "100%",
                                                }}
                                            >
                                                {item.pesquisas.map((pesquisa) => (
                                                    <div
                                                        key={pesquisa.codigo}
                                                        style={{
                                                            backgroundImage: `url('${pesquisa.urlAcesso}/ImagemChamada.ashx?token=${pesquisa.token}')`,
                                                            backgroundRepeat: "no-repeat",
                                                            backgroundSize: "100% 100%",
                                                        }}
                                                    >
                                                        <p>{pesquisa.descricaoPergunta}</p>
                                                        <ul
                                                            style={{
                                                                padding: 0,
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {this.getArrayFrom(pesquisa.metodoNps ? 10 : 5).map((resposta) => (
                                                                <li key={resposta} style={{ listStyle: "none" }}>
                                                                    <a
                                                                        href={`${pesquisa.urlAcesso}?token=${pesquisa.token}&resposta=${resposta}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        onClick={(e) => this.onPressPesquisa(e, item, pesquisa)}
                                                                    >
                                                                        <img
                                                                            src={`${pesquisa.urlAcesso}/Imagens/${
                                                                                pesquisa.tipoResposta === 1
                                                                                    ? `estrela${
                                                                                          this.state.pesquisa === item.ateCod &&
                                                                                          resposta <= this.state.resposta
                                                                                              ? 1
                                                                                              : 2
                                                                                      }`
                                                                                    : `${pesquisa.tipoResposta === 0 ? "face" : "cor"}${
                                                                                          pesquisa.metodoNps ? "" : "5"
                                                                                      }${resposta}`
                                                                            }.png`}
                                                                            alt={`Resp. ${resposta}`}
                                                                            style={{
                                                                                width: "100%",
                                                                                maxHeight: 50,
                                                                                borderStyle: "solid",
                                                                                borderColor: "#f00",
                                                                                borderRadius: "10%",
                                                                                borderWidth:
                                                                                    this.state.pesquisa === item.ateCod &&
                                                                                    resposta === this.state.resposta
                                                                                        ? 2
                                                                                        : 0,
                                                                                margin:
                                                                                    this.state.pesquisa === item.ateCod &&
                                                                                    resposta === this.state.resposta
                                                                                        ? 0
                                                                                        : 2,
                                                                                boxSizing:
                                                                                    this.state.pesquisa === item.ateCod &&
                                                                                    resposta === this.state.resposta
                                                                                        ? "content-box"
                                                                                        : "border-box",
                                                                            }}
                                                                            onMouseEnter={() =>
                                                                                this.setState({ resposta, pesquisa: item.ateCod })
                                                                            }
                                                                            onMouseLeave={() =>
                                                                                this.setState({ resposta: 0, pesquisa: "" })
                                                                            }
                                                                        />
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : null}
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid>
        );
    }
}

export default Resultados;
